<template>
  <div>
    <opq-basic-appbar>Confirmation de vos disponibilités inscrites au service de référence</opq-basic-appbar>
    <v-main>
      <v-card max-width="960" class="pa-4 pa-md-12 my-md-12 my-0 mx-auto">
        <mise-a-jour-service-reference class="mx-3 mx-md-auto" />
      </v-card>
    </v-main>
  </div>
</template>

<script>
import AppbarBase from "@/mixins/AppbarBase"
import MiseAJourServiceReference from "@/components/MiseAJourServiceReference/master.vue"
export default {
  mixins: [AppbarBase],
  components: {
    MiseAJourServiceReference
  }
}
</script>

<style lang="scss">
html {
  overflow: auto;
}
</style>

